<template>
    <div class="info content">
        <div class="bread">
            <bread :data="[{path: '/guide', title: '代理机构'}]"></bread>
        </div>
        <card class="search">
            <div class="title">
                <div class="text">
                    代理机构列表<span style="color:#999;font-size:14px">(只展示部分代理)</span>
                </div>

                <div class="search-con">
                    <el-input v-model="pgData.zbdlname" size="middle">
                        <el-button slot="append" @click="queryData">搜索</el-button>
                    </el-input>
                </div>
            </div>

        </card>

        <card class="list" v-loading="loadingController">

            <el-table :data="tableData" border style="width:100%;">
                <el-table-column
                    type="index"
                    width="50">
                </el-table-column>
                <el-table-column
                    property="zbdlname"
                    label="招标代理名称"
                    min-width="120">
                </el-table-column>
            </el-table>


            <my-pagination
                ref="page"
                class="page"
                :action="`${$store.state.api.webUrl}/index/zbdlinfo/pglist.json`"
                v-model="tableData"
                :search="pgData"
                :loading.sync="loadingController"
            ></my-pagination>

            <div style="text-align:center;margin-top:40px">
                <el-button type="primary" @click="goZbr">前往招标人系统</el-button>
            </div>
        </card>
    </div>
</template>

<script>
    import CONFIG from '@config/index';

    import Bread from '@components/sys/bread';
    import Card from '@components/sys/card';
    import List from '@components/sys/list';
    export default {
        components: {
            Bread,
            Card,
            List
        },
        data: () => ({
            tableData:[],
            pgData:{
                zbdlname:'',
                featurecode:CONFIG.head.planName,
                sortorder:'zbdlname',
                pagesize:10
            },
            loadingController: false,
        }),
        methods: {
            queryData() {
                this.$refs.page.queryData();
            },
            goZbr(){
                window.open('http://27.128.162.40:8088/otc/#/login?plan=nm&mRole=tender')
            }
        }
    }
</script>

<style lang="scss" scoped>
@import '@css/var.scss';
.info{
    .search{
        margin-bottom: 12px;

        .title {
            color: $primaryColor;
            font-size: 18px;
            font-weight: bold;
            overflow: hidden;

            .text{
                margin-top: 8px;
                float: left;
            }

            .search-con{
                width: 570px;
                float: right;

                ::v-deep {
                    .el-input__inner{
                        border-color: $primaryColor;
                        border-radius: 0;
                    }

                    .el-input-group__append{
                        border-radius: 0;
                        border-color: $primaryColor;
                        background-color: $primaryColor;
                        color: white;
                    }
                }
            }
        }
    }

    .list{
        min-height: 500px;
        margin-bottom: 20px;
    }
    .page{
        margin-top: 40px;
    }
}

</style>

